import { downloadBffFile, fetchBffBlob, jsonPost, saveBlob } from "../../common/download/downloadBffFile";

export const downloadFilteredIfrsReport = (encodedQ: string) =>
  downloadBffFile(`/api/contracts/ifrs-report/filtered?q=${encodeURIComponent(encodedQ)}`, ifrsReportFileName(new Date()));

export const downloadChosenIfrsReport = async (contractIds: string[], period: { from: string; to: string }) => {
  const file = await fetchBffBlob(
    "/api/contracts/ifrs-report/chosen",
    jsonPost({ contractIds, periodFrom: period.from, periodTo: period.to }),
  );
  saveBlob(file, ifrsPeriodReportFileName(period));
};

export const ifrsPeriodReportFileName = (period: { from: string; to: string }): string =>
  `IFRS16-rapport-${period.from}-til-${period.to}.xlsx`;

export const downloadSelectedContractsIfrsReport = (contractIds: string[]) =>
  downloadBffFile(`/api/contracts/ifrs-report?contractIds=${contractIds.join(",")}`, ifrsReportFileName(new Date()));

export const downloadContractIfrsReport = (contract: { id: string; title: string }) =>
  downloadBffFile(`/api/contracts/${contract.id}/ifrs-report`, contractIfrsReportFileName(contract.title));

export const ifrsReportFileName = (now: Date): string => `IFRS16-rapport-${now.toLocaleDateString("sv-SE")}.xlsx`;

export const contractIfrsReportFileName = (title: string): string =>
  `${Array.from(title).filter((c) => /[\p{L}\p{N}-]/u.test(c)).join("") || "IFRS16-rapport"}.xlsx`;
